import * as React from "react";
import { CartItem, spd, Transfer, TransferMethod } from "../../domain/payment";
import { Typography } from "@mui/material";
import { useOptionalState } from "../../utils/useOptionalState";
import { pipe } from "fp-ts/function";
import { option } from "fp-ts";
import { useSupabase } from "../../utils/supabase/useSupabase";
import { QrDataUrl, qrDataUrl } from "./QrCode";
import { TransferView } from "./TransferView";
import { CenteredProgress } from "../common/CenteredProgress";

interface Props {
    transferMethod: TransferMethod;
    amount: number;
    items: Array<CartItem>;
    eventId: number;
}

export const TransferCheckout = (p: Props) => {
    const qrDataUrlState = useOptionalState<QrDataUrl>();
    const transferState = useOptionalState<Transfer>();
    const client = useSupabase();
    const email = client.auth.user()?.email + "";

    React.useEffect(() => {
        fetch("/api/transfer-payment-intent", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                items: p.items,
                email,
                eventId: p.eventId,
            }),
        }).then((res) =>
            res.json().then((res) => {
                const vs = res.paymentId + "";

                const transfer: Transfer = {
                    amount: p.amount,
                    currency: "CZK",
                    iban: p.transferMethod.iban,
                    bic: p.transferMethod.bic,
                    reference: vs,
                    msg: p.eventId == 121 ? "IZS " + email : email,
                };

                transferState.set(transfer);

                qrDataUrl(spd(transfer)).then((url) => {
                    qrDataUrlState.set(url);
                });
            })
        );
    }, []);

    return (
        <>
            <Typography variant={"h4"}>Platební pokyny</Typography>
            <Typography variant={"body1"} gutterBottom>
                Prosíme, nezapomeňte vyplnit variabilní symbol. Bez něj se
                nemusí podařit platbu s vaší registrací spárovat.
            </Typography>
            {p.eventId != 166 ? null : (
                <Typography variant={"body1"}>
                    Pokud chcete účel naší akce podpořit ještě více, částku
                    můžete libovolně navýšit.
                </Typography>
            )}

            {pipe(
                transferState.value,
                option.fold(
                    () => <CenteredProgress />,
                    (transfer) => (
                        <TransferView
                            transfer={transfer}
                            qrDataUrl={qrDataUrlState.value}
                        />
                    )
                )
            )}
        </>
    );
};
